import { Config } from './config-viewmodel';
import { UserProfile, PhoneNumber, Address, Ice } from './user-profile-viewmodel';
import { Country } from './country-viewmodel';
import { IDictionary } from '@/shared/models/interface/dictionary-model';

export class Section {
    constructor(
        public open: boolean = false,
        public loading: boolean = false,
        public submitted: boolean = false,
        public success: boolean = false,
        public error: boolean = false,
        public fieldErrors: [] = []
    ){}   
}

export interface FormData {
    phoneNumbers: PhoneNumber[],
    correspondence: Address,
    temporary: Address,
    ice: PhoneNumber[]
}

export interface UserProfileState {
    loading: boolean,
    config: Config,
    error: string,
    profileData?: UserProfile,
    countries?: Country[],
    formSection: IDictionary<Section>,
    formData: FormData
}